<template>
    <app-layout>
        <template #header>
            <h2 class="title">
                Sorry, something went wrong
            </h2>
        </template>

        <div class="py-2">
            <div>
                <div class="bg-white p-3">
                  <div class="row">
            <div class="col-sm-12">

                <p>
                    A server error has occurred. Our team has been notified and is looking into it.
                </p>

                <div class="col-12 col-lg-2 d-flex align-items-end mb-4">
                    <jet-button class="text-nowrap mt-3 mt-lg-0 m-w-100" type="button" @click="$inertia.visit('/')">
                      Try Again
                    </jet-button>
                </div>
            </div>
                </div>
            </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'

export default {
    components: {
        AppLayout
    },
    props: {
        status: Number
    }
}
</script>
